document.addEventListener("DOMContentLoaded", () => {
	const accordian = document.querySelectorAll("[data-accordian]");
	accordian.forEach(accordian => {
		const title = accordian.querySelector("[data-accordian-title]");

		if (!title) return;

		title.addEventListener("click", () => {
			accordian.classList.toggle("active");
		});
	});
});
